import axios from "axios";

const baseURL = process.env.API.TMF_URL;

/**
 * axiosの設定を定義します
 */
const repository = axios.create({
  baseURL: baseURL,
  // headers: {
  //   "Content-Type": "application/json",
  // },
  // responseType: "json",
  // withCredentials: true,
});

/**
 * キャッシュ効率化のため、値が空文字列("")のクエリパラメータを送信前に除去する。
 * axiosのbuildURLはnull/undefinedは除外するが""は`key=`のまま残してしまうための対策。
 */
repository.interceptors.request.use((config) => {
  const { params } = config;
  if (
    params &&
    typeof params === "object" &&
    !(params instanceof URLSearchParams)
  ) {
    Object.keys(params).forEach((key) => {
      if (params[key] === "") {
        delete params[key];
      }
    });
  }
  return config;
});

export default repository;



// WEBPACK FOOTER //
// ./src/api/Repository.js